import { motion } from "framer-motion";
import { ImageComparisonSlider } from "@/components/ui/image-comparison-slider";
import beforeImage from "@/assets/comparison-before.png";
import afterImage from "@/assets/comparison-after.png";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.12, duration: 0.5, ease: "easeOut" as const },
  }),
};

const ComparisonSection = () => {
  return (
    <section className="py-20 md:py-28 relative">
      <div className="relative z-10 max-w-5xl mx-auto px-4">
        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          custom={0}
          className="text-3xl md:text-5xl font-bold text-center mb-4 tracking-tight text-gray-900"
        >
          Poczuj różnicę<span className="text-primary">.</span>
        </motion.h2>
        <motion.p
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          custom={1}
          className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-xl mx-auto"
        >
          Przesuń suwak i zobacz jak wygląda profesjonalna realizacja
        </motion.p>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          variants={fadeUp}
          custom={2}
          className="flex justify-center"
        >
          <ImageComparisonSlider
            beforeImage={beforeImage}
            afterImage={afterImage}
            beforeLabel="Samodzielnie"
            afterLabel="Z naszą ekipą"
            className="w-full max-w-[500px] aspect-[7/10] rounded-2xl shadow-2xl shadow-black/40"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default ComparisonSection;
